// Dependencies
import React from 'react';
import PropTypes from 'prop-types';

/// Components
import Image from '../../image/image';

// Styles
import BlogPostFeaturedImageStyles from './blogPostFeaturedImage.styles';

export default function BlogPostFeaturedImage({ featuredImage, fit }) {
  return (
    <BlogPostFeaturedImageStyles fit={fit}>
      <Image image={featuredImage?.node} filter className="featured-img" />
    </BlogPostFeaturedImageStyles>
  );
}

BlogPostFeaturedImage.propTypes = {
  featuredImage: PropTypes.shape({
    altText: PropTypes.string,
    node: PropTypes.shape({
      gatsbyImage: PropTypes.shape({}),
    }),
  }).isRequired,
  fit: PropTypes.string,
};

BlogPostFeaturedImage.defaultProps = {
  fit: '',
};
